import { useLayoutEffect, useState } from 'react';
export const useElementWidth = () => {
  const [element, setElement] = useState(null);
  const [width, setWidth] = useState(null);
  useLayoutEffect(() => {
    if (!element || typeof ResizeObserver === 'undefined') {
      return;
    }
    const updateWidth = () => setWidth(element.offsetWidth);
    updateWidth();
    const resizeObserver = new ResizeObserver(updateWidth);
    resizeObserver.observe(element);
    return () => resizeObserver.disconnect();
  }, [element]);
  return [width, setElement];
};